module.exports = __webpack_public_path__ + "7b1d2334374bfee9ee4cf18d31385882.woff";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-SemiBoldItalic.woff
// module id = 1808
// module chunks = 1